import { SUB_JOB_ISSUE_TRANSACTION_REQUEST, GET_SUB_JOB_ISSUE_TRANSACTIONS_TAKA_NO, SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE,
  GET_SUB_JOB_ISSUE_TRANSACTIONS } from '../types';

const initialState = {
  transactions: [],
  takaNos: [],
  loading: false,
  error: null,
};

const subJobIssueTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUB_JOB_ISSUE_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_SUB_JOB_ISSUE_TRANSACTIONS: {
      return {
        ...state,
        transactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_SUB_JOB_ISSUE_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case SUB_JOB_ISSUE_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default subJobIssueTransactionReducer;
